import { initialAWBState } from "../constants/awb";
import { Types } from "../actions/awb";

export const awbReducer = (state = initialAWBState, action) => {
    switch (action.type) {
        case Types.GET_AWB_SUCCESS:
            return {
                ...state,
                loading:false,
                [`${action.payload.key}`]:  action.payload.value 
            };
         case Types.GET_AWB_REQUEST:
             return {
                 ...state,
                 loading:action.payload.loading
            }
            
        case Types.GET_AWB_FAILURE:
            return {
                ...state,
                loading:false
            };   
        default:
            return state;
    }
};
